import axios from '@/libs/api.request'

export const getAccounts = (data) => {
  return axios.request({
    url: `/accounts/search`,
    method: 'get',
    params: data
  })
}

export const getAccount = (id) => {
  return axios.request({
    url: `/accounts/${id}`,
    method: 'get'
  })
}

export const updateAccount = (id, data) => {
  return axios.request({
    url: `/accounts/${id}`,
    method: 'put',
    data
  })
}

export const deleteAccount = (id) => {
  return axios.request({
    url: `/accounts/${id}`,
    method: 'delete'
  })
}

export const searchAccount = (query) => {
  return axios.request({
    url: `/search/account`,
    method: 'get',
    params: query
  })
}

export const getCustomerProvidedByAccount = (accountId) => {
  return axios.request({
    url: `/customer-provided-parts/by-account/${accountId}`,
    method: 'get'
  })
}

export const updateCustomerProvidedByAccount = (data) => {
  return axios.request({
    url: `/customer-provided-parts/save`,
    method: 'post',
    data
  })
}

export const deleteCustomerProvidedByAccount = (accountId) => {
  return axios.request({
    url: `/customer-provided-parts/${accountId}`,
    method: 'delete'
  })
}

export const getAccountRecentActivitiesSummary = (accountId) => {
  return axios.request({
    url: `/accounts/${accountId}/recent-activities`
  })
}
